import { render } from "./NotificationDetailComponent.vue?vue&type=template&id=c4f2af7a"
import script from "./NotificationDetailComponent.vue?vue&type=script&lang=js"
export * from "./NotificationDetailComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__